import {
  isValidElement,
  type PropsWithChildren,
  type ReactElement,
  type ReactNode,
} from 'react';

import type { DataTableRowData } from '../../public.api.js';

/**
 * Props for the `DataTableRowActions` component.
 * @public
 */
export interface DataTableRowActionsProps<TData extends DataTableRowData> {
  children: (
    row: TData,
    {
      rowDensity,
      rowIndex,
      rowId,
    }: {
      rowDensity: 'default' | 'condensed' | 'comfortable';
      rowIndex: number;
      rowId: string;
    },
  ) => ReactElement<PropsWithChildren>;
}

/**
 * The slot component for defining row actions within the DataTable.
 * @public
 */
export function DataTableRowActions<TData extends DataTableRowData>(
  props: DataTableRowActionsProps<TData>,
) {
  return null;
}

/**
 * Typeguard function that will check if a ReactNode is of type DataTableRowActions.
 * @internal
 */
export function isDataTableRowActions<TData extends DataTableRowData>(
  child: ReactNode,
): child is ReactElement<DataTableRowActionsProps<TData>> {
  if (isValidElement(child) && child.type === DataTableRowActions) {
    return true;
  }
  return false;
}
